export default __webpack_public_path__ + "static/educaHistoria-fa819c21aae10772ba4074c31a47a527.jpeg";